module.exports = __webpack_public_path__ + "static/img/Deployment 1 - Presentation.3e5de20.png";